export default __webpack_public_path__ + "static/media/covid19-treatment-4.98b1552f.svg";